import * as React from 'react'

import { useTheme } from '@emotion/react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

// TODO: move icons out to their own file
const CashIcon = ({ foreground }: { foreground: React.SVGProps<SVGPathElement>['fill'] }) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path
      d="M19.657 14.518c-.822 0-1.558.187-2.081.527-.517.337-.826.82-.826 1.443 0 .418.148.737.414 1 .273.268.676.483 1.193.666h.002c.476.175 1.052.322 1.677.482l.367.094c.76.197 1.568.42 2.305.733.737.313 1.418.723 1.915 1.299.501.58.807 1.322.807 2.276 0 1.284-.54 2.406-1.516 3.203-.973.796-2.367 1.259-4.07 1.259-2.188 0-4.254-.823-5.598-2.533a.471.471 0 01.123-.683l1.01-.672c.232-.154.542-.088.717.129.942 1.161 2.322 1.741 3.851 1.741 1.007 0 1.81-.24 2.357-.644.54-.4.84-.967.84-1.662 0-.367-.083-.654-.231-.89-.15-.237-.372-.434-.668-.606-.602-.35-1.466-.576-2.53-.834-1.208-.266-2.513-.592-3.516-1.211-1.018-.628-1.734-1.565-1.734-3.029 0-1.353.627-2.388 1.605-3.078.971-.686 2.284-1.028 3.67-1.028 1.979 0 3.784.738 5.103 2.168a.472.472 0 01-.089.706l-.941.663a.538.538 0 01-.691-.079c-.916-.935-2.122-1.44-3.465-1.44z"
      fill={foreground}
    />
    <rect x="19" y="10.75" width="2" height="18.5" rx=".25" fill={foreground} />
  </svg>
)

const HomeIcon = ({ foreground }: { foreground: React.SVGProps<SVGPathElement>['fill'] }) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.2 34.31a1.1 1.1 0 00-1.1-1.1h-2.2a1.1 1.1 0 00-1.1 1.1v3.436a1.1 1.1 0 01-1.1 1.1h-4.4a1.1 1.1 0 01-1.1-1.1v-6.875a1.1 1.1 0 01.422-.866l8.039-6.293a.55.55 0 01.678 0l8.04 6.293a1.1 1.1 0 01.421.866v6.875a1.1 1.1 0 01-1.1 1.1h-4.4a1.1 1.1 0 01-1.1-1.1V34.31z"
      fill={foreground}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 26.174c0-.334.152-.65.413-.859l10.243-8.195a.55.55 0 01.688 0l10.243 8.195a1.1 1.1 0 01.413.86v2.22a.55.55 0 01-.88.44l-9.79-7.342a.55.55 0 00-.66 0l-9.79 7.343a.55.55 0 01-.88-.44v-2.222z"
      fill={foreground}
    />
  </svg>
)

type ProgressIcons = 'cash' | 'home'

type Props = {
  icon?: ProgressIcons
  disabled?: boolean
  progress: number
  secondaryCircleTransparent?: boolean
  children?: React.ReactNode
}

// TODO: fix classname typing, should not have to be optional
const IconContainer = ({
  className,
  icon,
  disabled,
  secondaryCircleTransparent = false,
  children,
}: Props & { className?: string }) => {
  const theme = useTheme()

  return (
    <div className={className}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <circle
          r="28"
          cx="32"
          cy="32"
          strokeOpacity={secondaryCircleTransparent ? 0 : 1}
          stroke={theme.colors.secondaryButtonBackground}
          strokeWidth="6"
          strokeDasharray="175.93"
          strokeDashoffset="0"
        />
        <circle
          r="28"
          cx="32"
          cy="32"
          stroke={disabled ? theme.colors.disabledLabel : theme.colors.primary}
          strokeWidth="6"
          fill="transparent"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="175.93"
          strokeDashoffset="0"
          transform="rotate(-90, 32, 32)"
        />
        {icon === 'cash' && (
          <g>
            <CashIcon foreground={disabled ? theme.colors.disabledLabel : theme.colors.primary} />
          </g>
        )}
        {icon === 'home' && (
          <g>
            <HomeIcon foreground={disabled ? theme.colors.disabledLabel : theme.colors.primary} />
          </g>
        )}
      </svg>
      <div className="innerLabelWrapper">{children}</div>
    </div>
  )
}
const calculateProgress = ({ progress }: Props) => 28 * Math.PI * 2 * (1 - progress)
export const Icon = styled(IconContainer)`
  position: relative;
  width: 100%;
  height: 100%;
  circle:last-of-type {
    transition: stroke-dashoffset 1s;
    stroke-dashoffset: ${calculateProgress};
  }
  ${props =>
    props.disabled &&
    css`
      circle:first-of-type {
        visibility: hidden;
      }
      circle:first-of-type + circle {
        visibility: hidden;
      }
    `}
  .innerLabelWrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    line-height: 1;
  }
`

export default Icon
